export const POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID = "122";
export const POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID = "126";
export const RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID = "124";
export const RP_WEBHOOK_URL_PROPERTY_TYPE_ID = "123";
export const RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID = "156";
export const RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID = "127";
export const RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID = "125";
export const RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID = "152";
export const RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID = "153";
export const RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID = "157";
export const RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID = "395";
export const RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID = "396";



export const WEBHOOK_CONFIGURATION_PROPERTY_TYPE_IDS = [
    POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID,
    POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID,
    RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID,
    RP_WEBHOOK_URL_PROPERTY_TYPE_ID,
    RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID,
    RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID,
];